export const elementCategoryKeys = {
  all: ["elementCategory"] as const,
  project: (projectId: string | null) => [...elementCategoryKeys.all, projectId] as const,
};
